import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';

export const ClickableBox = styled(ButtonBase)({
  display: 'block',
  textAlign: 'inherit',
});
